

const ERROR_MSG = '请先选择有效记录，再执行该操作！'

function joinObj(target, obj) {
  if (obj) {
    for (const item in obj) {
      target[item] = obj[item]
    }
  }
}

let exportParam = {

  //初始化
  init(entity, handle, callback) {
    entity.loading = true
    handle(entity.query)
        .then(res => {
          entity.list = res
          callback && callback(res)
        })
        .finally(() => {
          entity.loading = false
        })
  },

  getLocal(key) {
    var obj = window.localStorage.getItem(key);
    try {
      if (obj && obj !== 'undefined' && obj !== 'null') {
        return JSON.parse(obj);
      }
    } catch (e) {
      return obj
    }
    return '';
  },
  // 弹窗相关
  getDialog(title = '', obj) {
    let dialog = {
      title: title,
      edit: false,
      show: false,
      loading: false,
      handle: () => {
      },
    }
    joinObj(dialog, obj)
    return dialog
  },
  showDialog(dialog, obj) {
    dialog.show = true
    dialog.loading = false
    dialog = joinObj(dialog, obj)
    return dialog
  },

  // 翻页通用参数
  getPage() {
    return {
      "page": {
        "current": 1,
        "size": 10,
        "total": 0,
      },
      "model": {

      }
    }
  },

  // 显示dialog
  show(dialog, handle, obj) {
    dialog.show = true
    dialog.loading = false
    dialog.handle = handle
    dialog = joinObj(dialog, obj)
    return dialog
  },

  // 显示新增dialog
  showAdd(dialog, handle, obj) {
    dialog.edit = false
    dialog.title = '新增'
    dialog = exportParam.show(dialog, handle, obj)
  },

  // 显示编辑dialog
  showEdit(dialog, handle, obj) {
    dialog.edit = true
    dialog.title = '修改'
    dialog = exportParam.show(dialog, handle, obj)
  },

  // 删除, 审核， 弃审
  operate(obj,txt, handle, param, init, callback, isNeedConfirm) {
    if(isNeedConfirm){
      obj.$store.commit('confirm', {
        content: `确定${txt}吗`,
        callback: (next, back) => {
          handle(param)
              .then(() => {
                init && init()
                obj.$help.success(`${txt}成功`)
                next()
                callback && callback()
              })
              .catch(error => {
                obj.$help.error(error.obj)
                back()
              })
        }
      })
    }else{
      handle(param)
          .then(() => {
            init && init()
            obj.$help.success(`${txt}成功`)
            callback && callback()
          })
          .catch(error => {
            obj.$help.error(error.obj)
          })
    }
  },

  Confirm(state, option = {}) {
    let defaultOption = {
      show: true,
      title: '提示',
      content: '',
      loading: false,
      callback: () => {
      },
    }
    state.alertInfo = joinObj(defaultOption, option)
  },

  // 合并参数
  joinObj() {
    var obj = {}
    for (let i = 0; i < arguments.length; i++) {
      Object.assign(obj, arguments[i])
    }
    return obj
  },

  // 通用访问接口
  dialogRequest(dialog, param, callback, msg) {
    dialog.loading = true
    dialog.handle(param)
      .then(res => {

        this.$help.success(msg ? msg : `${dialog.title}成功`)
        callback && callback(res)
        dialog.show = false
      })
      .catch(error => {
        this.$help.error(error.error || error.obj)
      })
      .finally(() => {
        dialog.loading = false
      })
  },

  ERROR_MSG,
}

export default exportParam
